import type { UploadMediaType } from '@/types/upload';

/**
 * Elapsed-time marks (ms) at which the upload copy escalates one step — one
 * mark, so one step: **the wording changes 5 seconds in**. 5s is past the point
 * a healthy upload would already be done, so a user who sees the second message
 * is genuinely waiting. Shared with `useUploadMessage`, which sets one timer
 * per mark, so the schedule is stated once.
 */
export const UPLOAD_MESSAGE_MARKS_MS = [5000];

interface GetUploadMessageParams {
  /** How many of `UPLOAD_MESSAGE_MARKS_MS` have elapsed since the upload began. */
  marksPassed: number;
  mediaType: UploadMediaType;
}

/**
 * Copy for an upload in flight. A message that *changes* is what proves the app
 * is alive — a spinner that never moves reads as a freeze, and the user leaves.
 *
 * Each string is a whole sentence rather than a stitched fragment, so it can be
 * translated as one key. No trailing ellipsis: callers render animated dots (or
 * a spinner) after it.
 */
const getUploadMessage = ({
  marksPassed,
  mediaType,
}: GetUploadMessageParams): string => {
  if (marksPassed >= 1) return 'Still uploading';

  return `Uploading ${mediaType}`;
};

export default getUploadMessage;
